module.exports = __webpack_public_path__ + "static/img/354503439.b5e1e7ee.png";